import {
  Component,
  Input,
  OnInit,
  ViewChild,
  TemplateRef,
  ViewContainerRef,
  OnDestroy,
} from '@angular/core';
import { ThemePalette } from '@angular/material/core';
import { ProgressSpinnerMode } from '@angular/material/progress-spinner';
import { OverlayRef } from '@angular/cdk/overlay';
import { AppOverlayConfig, OverlayService } from './overlay.service';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { ContainsSubscriptions } from '../../../core/services/interfaces/contains-subscriptions';
import { Subscription } from 'rxjs/Rx';
import { unsubscribeFromAll } from '../../../core/pure-functions/rx-helper';

@Component({
  selector: 'app-progress-spinner-overlay',
  templateUrl: './progress-spinner-overlay.component.html',
})
export class ProgressSpinnerComponent
  implements OnInit, ContainsSubscriptions, OnDestroy
{
  @Input() color?: ThemePalette;
  @Input() diameter = 100;
  @Input() mode?: ProgressSpinnerMode;
  @Input() strokeWidth?: number;
  @Input() value?: number;
  @Input() backdropEnabled = true;
  @Input() positionGloballyCenter = true;
  @Input() displayProgressSpinner: BehaviorSubject<boolean>;
  @Input() message = '';

  @ViewChild('progressSpinnerRef', { static: true })
  private progressSpinnerRef: TemplateRef<any>;
  private progressSpinnerOverlayConfig: AppOverlayConfig;
  private overlayRef: OverlayRef;
  subs: Subscription[] = [];

  constructor(
    private vcRef: ViewContainerRef,
    private overlayService: OverlayService,
  ) {}

  ngOnInit() {
    // Config for Overlay Service
    this.progressSpinnerOverlayConfig = {
      hasBackdrop: this.backdropEnabled,
    };
    if (this.positionGloballyCenter) {
      this.progressSpinnerOverlayConfig['positionStrategy'] =
        this.overlayService.positionGloballyCenter();
    }
    // Create Overlay for progress spinner
    this.overlayRef = this.overlayService.createOverlay(
      this.progressSpinnerOverlayConfig,
    );

    this.displayProgressSpinner.subscribe((show) => {
      if (show) {
        this.overlayService.attachTemplatePortal(
          this.overlayRef,
          this.progressSpinnerRef,
          this.vcRef,
        );
      } else {
        this.overlayRef.detach();
      }
    });
  }

  ngOnDestroy() {
    unsubscribeFromAll(this.subs);
  }
}
